import styled from '@emotion/styled';
import { ReactComponent as SparkyLogo } from '@svg/common/studio-beta-logo.svg';

export default styled(SparkyLogo)`
  .logo path {
    ${({ theme }) =>
      theme.name === 'dark' &&
      `
      fill: #ffffff !important;
    `}
  }
`;
